export const momentsByMonth = {
    Março: [
        {
            name: "Trote Solidário - Doação de Leite para o Hospital de Esperança",
            date: "07 de Março",
            theme: "Solidariedade",
            photos: [
                 "/assets/fotosTroteLeite/Foto1.jpeg",
                "/assets/fotosTroteLeite/Foto2.jpeg",
            ],
        },
        {
            name: "Dia da Mulher",
            date: "08 de Março",
            theme: "Homenagem às Mulheres",
            photos: [
                "/assets/fotosDiaMulher/Foto1.jpeg",
                "/assets/fotosDiaMulher/Foto2.jpeg",
            ],
        },
        {
            name: "Linha do Tempo dos Sonhos",
            date: "10 de Março",
            theme: "Construindo Sonhos",
            photos: [
                "/assets/fotosLinhaTempo/Foto1.jpeg",
                "/assets/fotosLinhaTempo/Foto2.jpeg",
            ],
        },
        {
            name: "Tech Quiz",
            date: "25 de Março",
            theme: "Quiz de Tecnologia",
            photos: [
                "/assets/fotosQuiz/foto1.jpeg",
                "/assets/fotosQuiz/foto2.jpeg",
                "/assets/fotosQuiz/foto3.jpeg",
                "/assets/fotosQuiz/foto4.jpeg",
                "/assets/fotosQuiz/foto5.jpeg",
                "/assets/fotosQuiz/foto6.jpeg",
                "/assets/fotosQuiz/foto7.jpeg",
                "/assets/fotosQuiz/foto8.jpeg",
            ],
        },
    ],
    Abril: [
        {
            name: "Bingo",
            date: "17 de Abril",
            theme: "Evento de Integração",
            photos: [
                "/assets/fotosBingo/Foto1.jpeg",
                "/assets/fotosBingo/Foto2.jpeg",
                "/assets/fotosBingo/Foto3.jpeg",
                "/assets/fotosBingo/Foto4.jpeg",
                "/assets/fotosBingo/Foto6.jpeg",
                "/assets/fotosBingo/Foto8.jpeg",
                "/assets/fotosBingo/Foto9.jpeg",
                "/assets/fotosBingo/Foto10.jpeg",
                "/assets/fotosBingo/Foto11.jpeg",
                "/assets/fotosBingo/Foto13.jpeg",
                "/assets/fotosBingo/Foto14.jpeg",
                "/assets/fotosBingo/Foto15.jpeg",
                "/assets/fotosBingo/Foto16.jpeg",
                "/assets/fotosBingo/Foto17.jpeg",
                "/assets/fotosBingo/Foto18.jpeg",
                "/assets/fotosBingo/Foto19.jpeg",
                "/assets/fotosBingo/Foto20.jpeg",
                "/assets/fotosBingo/Foto21.jpeg",
                "/assets/fotosBingo/Foto24.jpeg",
                "/assets/fotosBingo/Foto25.jpeg",
                "/assets/fotosBingo/Foto26.jpeg",
                "/assets/fotosBingo/Foto27.jpeg",
                "/assets/fotosBingo/Foto28.jpeg",
                "/assets/fotosBingo/Foto29.jpeg",
                "/assets/fotosBingo/Foto30.jpeg",
                "/assets/fotosBingo/Foto35.jpeg",
                "/assets/fotosBingo/Foto36.jpeg",
                "/assets/fotosBingo/Foto38.jpeg",
                "/assets/fotosBingo/Foto39.jpeg",
                "/assets/fotosBingo/Foto40.jpeg",
                "/assets/fotosBingo/Foto41.jpeg",
                "/assets/fotosBingo/Foto42.jpeg",
                "/assets/fotosBingo/Foto43.jpeg",
                "/assets/fotosBingo/Foto44.jpeg",
                "/assets/fotosBingo/Foto45.jpeg",
            ],
        },
    ],
    Maio: [
        {
            name: "Entrega dos Kits de Arduino",
            date: "06 de Maio",
            theme: "Tecnologia e Aprendizado",
            photos: [
                "/assets/fotosArduino/Foto1.jpeg",
                "/assets/fotosArduino/Foto2.jpeg",
                "/assets/fotosArduino/Foto3.jpeg",
                "/assets/fotosArduino/Foto4.jpeg",
                "/assets/fotosArduino/Foto5.jpeg",
                "/assets/fotosArduino/Foto6.jpeg",
                "/assets/fotosArduino/Foto7.jpeg",
                "/assets/fotosArduino/Foto8.jpeg",
                "/assets/fotosArduino/Foto9.jpeg",
                "/assets/fotosArduino/Foto10.jpeg",
                "/assets/fotosArduino/Foto11.jpeg",
                "/assets/fotosArduino/Foto12.jpeg",
                "/assets/fotosArduino/Foto13.jpeg",
            ],
        },
        {
            name: "Apresentação do Projeto APAE",
            date: "07 de Maio",
            theme: "Educação e Inclusão",
            photos: [
                "/assets/fotosApae/Foto1.jpeg",
                "/assets/fotosApae/Foto2.jpeg",
                "/assets/fotosApae/Foto3.jpeg",
                "/assets/fotosApae/Foto4.jpeg",
                "/assets/fotosApae/Foto5.jpeg",
                "/assets/fotosApae/Foto6.jpeg",
                "/assets/fotosApae/Foto7.jpeg",
                "/assets/fotosApae/Foto8.jpeg",
                "/assets/fotosApae/Foto9.jpeg",
                "/assets/fotosApae/Foto10.jpeg",
                "/assets/fotosApae/Foto11.jpeg",
                "/assets/fotosApae/Foto12.jpeg",
                "/assets/fotosApae/Foto13.jpeg",
                "/assets/fotosApae/Foto14.jpeg",
                "/assets/fotosApae/Foto15.jpeg",
                "/assets/fotosApae/Foto16.jpeg",
                "/assets/fotosApae/Foto17.jpeg",
                "/assets/fotosApae/Foto18.jpeg",
            ],
        },
        {
            name: "Maratona de Programação Inter Fatecs",
            date: "10 de Maio",
            theme: "Competição de Programação",
            photos: [
                "/assets/fotosMaratona/Foto1.jpeg",
                "/assets/fotosMaratona/Foto2.jpeg",
                "/assets/fotosMaratona/Foto3.jpeg",
                "/assets/fotosMaratona/Foto4.jpeg",
                "/assets/fotosMaratona/Foto5.jpeg",
                "/assets/fotosMaratona/Foto6.jpeg",
                "/assets/fotosMaratona/Foto7.jpeg",
                "/assets/fotosMaratona/Foto8.jpeg",
                "/assets/fotosMaratona/Foto9.jpeg",
                "/assets/fotosMaratona/Foto10.jpeg",
            ],
        },
        {
            name: "Apresentação de Artigo no CIC",
            date: "13 de Maio",
            theme: "Congresso de Iniciação Científica",
            photos: [
                "/assets/fotosCic/Foto1.jpeg",
                "/assets/fotosCic/Foto2.jpeg",
                "/assets/fotosCic/Foto3.jpeg",
                "/assets/fotosCic/Foto4.jpeg",
                "/assets/fotosCic/Foto5.jpeg",
                "/assets/fotosCic/Foto6.jpeg",
                "/assets/fotosCic/Foto7.jpeg",
            ],
        },
        {
            name: "Trote Solidário - Campanha do Agasalho",
            date: "20 de Maio",
            theme: "Solidariedade e Responsabilidade Social",
            photos: [
                "/assets/fotosAgasalho/Foto1.jpeg",
                "/assets/fotosAgasalho/Foto2.jpeg",
                "/assets/fotosAgasalho/Foto3.jpeg",
                "/assets/fotosAgasalho/Foto4.jpeg",
                "/assets/fotosAgasalho/Foto5.jpeg",
                "/assets/fotosAgasalho/Foto6.jpeg",
                "/assets/fotosAgasalho/Foto7.jpeg",
                "/assets/fotosAgasalho/Foto8.jpeg",
                "/assets/fotosAgasalho/Foto9.jpeg",
                "/assets/fotosAgasalho/Foto10.jpeg",
                "/assets/fotosAgasalho/Foto11.jpeg",
            ],
        },
        {
            name: "Hackathon Tech4Health - Ideathon (1° Fase)",
            date: "21 de Maio",
            theme: "Inovação em Saúde - Ideathon",
            photos: [
                "/assets/fotosHackathon/IdeathonFoto1.jpeg",
                "/assets/fotosHackathon/IdeathonFoto2.jpeg",
                "/assets/fotosHackathon/IdeathonFoto3.jpeg",
                "/assets/fotosHackathon/IdeathonFoto4.jpeg",
                "/assets/fotosHackathon/IdeathonFoto5.jpeg",
                "/assets/fotosHackathon/IdeathonFoto6.jpeg",
                "/assets/fotosHackathon/IdeathonFoto7.jpeg",
                "/assets/fotosHackathon/IdeathonFoto8.jpeg",
                "/assets/fotosHackathon/IdeathonFoto9.jpeg",
                "/assets/fotosHackathon/IdeathonFoto10.jpeg",
                "/assets/fotosHackathon/IdeathonFoto11.jpeg",
                "/assets/fotosHackathon/IdeathonFoto12.jpeg",
                "/assets/fotosHackathon/IdeathonFoto13.jpeg",
                "/assets/fotosHackathon/IdeathonFoto14.jpeg",
                "/assets/fotosHackathon/IdeathonFoto15.jpeg",
                "/assets/fotosHackathon/IdeathonFoto16.jpeg",
                "/assets/fotosHackathon/IdeathonFoto17.jpeg",
            ],
        },
        {
            name: "Hackathon Tech4Health - Prototipagem (2° Fase)",
            date: "22 de Maio",
            theme: "Inovação em Saúde - Prototipagem",
            photos: [
                "/assets/fotosHackathon/PrototipagemFoto1.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto2.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto3.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto4.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto5.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto6.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto7.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto8.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto9.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto10.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto11.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto12.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto13.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto14.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto15.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto16.jpeg",
                "/assets/fotosHackathon/PrototipagemFoto17.jpeg",
            ],
        },
    ],
    Junho: [
        {
            name: "Deploy de Carreira - Bate-papo com Egressos",
            date: "17 de Junho",
            theme: "Orientação Profissional e Networking",
            photos: [
                "/assets/fotosDeployCarreira/Foto1.jpeg",
                "/assets/fotosDeployCarreira/Foto2.jpeg",
                "/assets/fotosDeployCarreira/Foto3.jpeg",
                "/assets/fotosDeployCarreira/Foto4.jpeg",
                "/assets/fotosDeployCarreira/Foto5.jpeg",
                "/assets/fotosDeployCarreira/Foto6.jpeg",
                "/assets/fotosDeployCarreira/Foto7.jpeg",
                "/assets/fotosDeployCarreira/Foto8.jpeg",
                "/assets/fotosDeployCarreira/Foto9.jpeg",
                "/assets/fotosDeployCarreira/Foto10.jpeg",
                "/assets/fotosDeployCarreira/Foto11.jpeg",
                "/assets/fotosDeployCarreira/Foto12.jpeg",
                "/assets/fotosDeployCarreira/Foto13.jpeg",
                "/assets/fotosDeployCarreira/Foto14.jpeg",
            ],
        },
    ],
    Agosto: [
         {
            name: "Quiz de Volta às Aulas",
            date: "07 de Agosto",
            theme: "Quiz de Volta às Aulas - integração e revisão de conceitos",
            photos: [
                "/assets/fotosQuizVoltaAsAulas/foto1.jpeg",
                "/assets/fotosQuizVoltaAsAulas/foto2.jpeg",
                "/assets/fotosQuizVoltaAsAulas/foto3.jpeg",
                "/assets/fotosQuizVoltaAsAulas/foto4.jpeg",
            ],
        },
        {
            name: "Hackathon Tech4Health - Final (3° Fase)",
            date: "15 de Agosto",
            theme: "Encerramento e Premiação",
            photos: [
                "/assets/fotosHackathon/FinalFoto2.jpeg",
                "/assets/fotosHackathon/FinalFoto3.jpeg",
                "/assets/fotosHackathon/FinalFoto4.jpeg",
                "/assets/fotosHackathon/FinalFoto5.jpeg",
                "/assets/fotosHackathon/FinalFoto6.jpeg",
                "/assets/fotosHackathon/FinalFoto7.jpeg",
                "/assets/fotosHackathon/FinalFoto8.jpeg",
                "/assets/fotosHackathon/FinalFoto9.jpeg",
                "/assets/fotosHackathon/FinalFoto10.jpeg",
                "/assets/fotosHackathon/FinalFoto11.jpeg",
                "/assets/fotosHackathon/FinalFoto12.jpeg",
                "/assets/fotosHackathon/FinalFoto13.jpeg",
                "/assets/fotosHackathon/FinalFoto14.jpeg",
                "/assets/fotosHackathon/FinalFoto15.jpeg",
                "/assets/fotosHackathon/FinalFoto16.jpeg",
                "/assets/fotosHackathon/FinalFoto17.jpeg",
            ],
        },
        {
            name: "2ª Fase da Maratona de Programação Inter Fatecs",
            date: "16 de Agosto",
            theme: "Competição de Programação - Fase Final",
            photos: [
                "/assets/fotosMaratona2Fase/Foto1.jpeg",
                "/assets/fotosMaratona2Fase/Foto2.jpeg",
                "/assets/fotosMaratona2Fase/Foto3.jpeg",
                "/assets/fotosMaratona2Fase/Foto4.jpeg",
                "/assets/fotosMaratona2Fase/Foto5.jpeg",
                "/assets/fotosMaratona2Fase/Foto6.jpeg",
            ],
        },
    ],
    Setembro: [
        {
            name: "Visita Técnica - Micro 2000",
            date: "02 de Setembro",
            theme: "Visita Técnica à Empresa Micro 2000",
            photos: [
                "/assets/fotosMicro2000/Foto1.jpeg",
                "/assets/fotosMicro2000/Foto2.jpeg",
                "/assets/fotosMicro2000/Foto3.jpeg",
                "/assets/fotosMicro2000/Foto4.jpeg",
                "/assets/fotosMicro2000/Foto5.jpeg",
                "/assets/fotosMicro2000/Foto6.jpeg",
                "/assets/fotosMicro2000/Foto7.jpeg",
                "/assets/fotosMicro2000/Foto8.jpeg",
                "/assets/fotosMicro2000/Foto9.jpeg",
                "/assets/fotosMicro2000/Foto10.jpeg",
                "/assets/fotosMicro2000/Foto11.jpeg",
                "/assets/fotosMicro2000/Foto12.jpeg",
                "/assets/fotosMicro2000/Foto13.jpeg",
                "/assets/fotosMicro2000/Foto14.jpeg",
                "/assets/fotosMicro2000/Foto15.jpeg",
            ],
        },
        {
            name: "Comemoração - Dia do Programador",
            date: "12 de Setembro",
            theme: "Comemoração do Dia do Programador",
            photos: [
                "/assets/fotosProgramador/Foto1.jpeg",
                "/assets/fotosProgramador/Foto2.jpeg",
                "/assets/fotosProgramador/Foto3.jpeg",
                "/assets/fotosProgramador/Foto4.jpeg",
                "/assets/fotosProgramador/Foto5.jpeg",
            ],
        },
        {
            name: "Integração que inspira!",
            date: "12 de Setembro",
            theme: "Alunos da Fatec e da Etec: bate-papo sobre curso superior, experiências e oportunidades + bingo digital temático",
            photos: [
                "/assets/fotosEtec/Foto1.jpeg",
                "/assets/fotosEtec/Foto2.jpeg",
                "/assets/fotosEtec/Foto3.jpeg",
                "/assets/fotosEtec/Foto4.jpeg",
                "/assets/fotosEtec/Foto5.jpeg",
                "/assets/fotosEtec/Foto6.jpeg",
                "/assets/fotosEtec/Foto7.jpeg",
                "/assets/fotosEtec/Foto8.jpeg",
                "/assets/fotosEtec/Foto9.jpeg",
            ],
        },
        {
            name: "Palestra Setembro Amarelo",
            date: "12 de Setembro",
            theme: "Viver a faculdade: relações, respeito e saúde mental - Prof. Jerson Joaquim da Silva",
            photos: [
                "/assets/fotosPalestras/Jerson/Foto1.jpeg",
                "/assets/fotosPalestras/Jerson/Foto2.jpeg",
                "/assets/fotosPalestras/Jerson/Foto3.jpeg",
                "/assets/fotosPalestras/Jerson/Foto4.jpeg",
                "/assets/fotosPalestras/Jerson/Foto5.jpeg",
            ],
        },
        {
            name: "Perfil em destaque: Do LinkedIn ao retrato — se destaque onde importa",
            date: "16 de Setembro",
            theme: "LinkedIn e marketing pessoal — Prof. Carolina Martins Fernandes",
            photos: [
                "/assets/fotosPalestras/Carolina/Foto1.jpeg",
                "/assets/fotosPalestras/Carolina/Foto2.jpeg",
                "/assets/fotosPalestras/Carolina/Foto3.jpeg",
                "/assets/fotosPalestras/Carolina/Foto4.jpeg",
            ],
        },
        {
            name: "Perfil em destaque: Sessão de Fotos Profissionais",
            date: "16 de Setembro",
            theme: "Sessão de Fotos Profissionais - Kelly Primiani",
            photos: [
                "/assets/fotosKelly/Foto1.jpeg",
                "/assets/fotosKelly/Foto2.jpeg",
                "/assets/fotosKelly/Foto3.jpeg",
                "/assets/fotosKelly/Foto4.jpeg",
                "/assets/fotosKelly/Foto5.jpeg",
            ],
        },
        {
            name: "III Simpósio InterAgro",
            date: "23 de Setembro",
            theme: "Simpósio Interdisciplinar - Agricultura e Inovação",
            photos: [
                "/assets/fotosInterAgro/Foto1.jpeg",
                "/assets/fotosInterAgro/Foto2.jpeg",
                "/assets/fotosInterAgro/Foto3.jpeg",
                "/assets/fotosInterAgro/Foto4.jpeg",
                "/assets/fotosInterAgro/Foto5.jpeg",
                "/assets/fotosInterAgro/Foto6.jpeg",
                "/assets/fotosInterAgro/Foto7.jpeg",
                "/assets/fotosInterAgro/Foto8.jpeg",
                "/assets/fotosInterAgro/Foto9.jpeg",
                "/assets/fotosInterAgro/Foto10.jpeg",
                "/assets/fotosInterAgro/Foto11.jpeg",
                "/assets/fotosInterAgro/Foto12.jpeg",
                "/assets/fotosInterAgro/Foto13.jpeg",
                "/assets/fotosInterAgro/Foto14.jpeg",
                "/assets/fotosInterAgro/Foto15.jpeg",
            ],
        },
    ],
        Outubro: [
        {
            name: "Palestra: Testes Unitários com Jest e Testing Library no React",
            date: "20 de Outubro",
            theme: "Joel Modesto - Desenvolvedor de Software na SoftPlan",
            photos: [
                "/assets/Setec 20-10 - palestras online/Joel - testes unitários em React/print1.png",
                "/assets/Setec 20-10 - palestras online/Joel - testes unitários em React/print2.png",
                "/assets/Setec 20-10 - palestras online/Joel - testes unitários em React/print3.png",
                "/assets/Setec 20-10 - palestras online/Joel - testes unitários em React/print4.png",
                "/assets/Setec 20-10 - palestras online/Joel - testes unitários em React/print5.png",
                "/assets/Setec 20-10 - palestras online/Joel - testes unitários em React/print6.png",
                "/assets/Setec 20-10 - palestras online/Joel - testes unitários em React/print7.png"
            ]
        },
        {
            name: "Palestra: Tuning em Banco de Dados - Índices e Estatísticas",
            date: "20 de Outubro",
            theme: "Diego Meidas Pinheiro - Size Fintech",
            photos: [
                "/assets/Setec 20-10 - palestras online/Diego - tuning em banco de dados/print1.png",
                "/assets/Setec 20-10 - palestras online/Diego - tuning em banco de dados/print2.png",
                "/assets/Setec 20-10 - palestras online/Diego - tuning em banco de dados/print3.png",
                "/assets/Setec 20-10 - palestras online/Diego - tuning em banco de dados/print4.png"
            ]
        },
        {
            name: "Palestra: A importância da disciplina de teste na engenharia de software",
            date: "21 de Outubro",
            theme: "Juliano Videira - Vericode Tecnologia",
            photos: [
                "/assets/Setec 21-10 - palestra/Foto1.jpg",
                "/assets/Setec 21-10 - palestra/Foto2.jpg",
                "/assets/Setec 21-10 - palestra/Foto3.jpg",
                "/assets/Setec 21-10 - palestra/Foto4.jpg",
                "/assets/Setec 21-10 - palestra/Foto5.jpg",
                "/assets/Setec 21-10 - palestra/Foto6.jpg",
                "/assets/Setec 21-10 - palestra/Foto7.jpg",
                "/assets/Setec 21-10 - palestra/Foto8.jpg",
                "/assets/Setec 21-10 - palestra/Foto9.jpg",
                "/assets/Setec 21-10 - palestra/Foto10.jpg",
                "/assets/Setec 21-10 - palestra/Foto11.jpg",
                "/assets/Setec 21-10 - palestra/Foto12.jpg",
                "/assets/Setec 21-10 - palestra/Foto13.jpg",
                "/assets/Setec 21-10 - palestra/Foto14.jpg",
                "/assets/Setec 21-10 - palestra/Foto15.jpg",
                "/assets/Setec 21-10 - palestra/Foto16.jpg",
                "/assets/Setec 21-10 - palestra/Foto17.jpg",
                "/assets/Setec 21-10 - palestra/Foto18.jpg",
                "/assets/Setec 21-10 - palestra/Foto19.jpg",
                "/assets/Setec 21-10 - palestra/Foto20.jpg",
                "/assets/Setec 21-10 - palestra/Foto21.jpg",
                "/assets/Setec 21-10 - palestra/Foto22.jpg",
                "/assets/Setec 21-10 - palestra/Foto23.jpg",
                "/assets/Setec 21-10 - palestra/Foto24.jpg",
                "/assets/Setec 21-10 - palestra/Foto25.jpg",
                "/assets/Setec 21-10 - palestra/Foto26.jpg",
                "/assets/Setec 21-10 - palestra/Foto27.jpg",
                "/assets/Setec 21-10 - palestra/Foto28.jpg"     
            ]
        },
        {
            name: "Minicurso: Leve sua ideia aos 5 continentes usando Google Cloud",
            date: "21 de Outubro",
            theme: "José Neto - Nuvem UAV",
            photos: [
                "/assets/Setec 21-10 - minicurso/Foto1.jpg",
                "/assets/Setec 21-10 - minicurso/Foto2.jpg",
                "/assets/Setec 21-10 - minicurso/Foto3.jpg",
                "/assets/Setec 21-10 - minicurso/Foto4.jpg",
                "/assets/Setec 21-10 - minicurso/Foto5.jpg",
                "/assets/Setec 21-10 - minicurso/Foto6.jpg",
            ]
        },
        {
            name: "Mostra de Trabalhos dos Alunos de ADS AMS",
            date: "22 de Outubro",
            theme: "Projetos Acadêmicos e Inovação",
            photos: [
                "/assets/Setec 22-10 - mostra de trabalhos/Foto1.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto2.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto3.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto4.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto5.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto6.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto7.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto8.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto9.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto10.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto11.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto12.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto13.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto14.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto15.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto16.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto17.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto18.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto19.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto20.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto21.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto22.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto23.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto24.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto25.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto26.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto27.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto28.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto29.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto30.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto31.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto32.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto33.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto34.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto35.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto36.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto37.jpg",
                "/assets/Setec 22-10 - mostra de trabalhos/Foto38.jpg",
                ]
        },
        {
            name: "Visita Técnica na Duesoft Sistemas",
            date: "23 de Outubro",
            theme: "Experiência Profissional e Tecnologia",
            photos: [
                "/assets/Setec 23-10 - visita técnica/Foto1.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto2.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto3.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto4.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto5.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto6.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto7.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto8.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto9.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto10.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto11.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto12.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto13.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto14.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto15.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto16.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto17.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto18.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto19.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto20.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto21.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto22.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto23.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto24.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto25.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto26.jpg",
                "/assets/Setec 23-10 - visita técnica/Foto27.jpg",
               ]
        },
        {
            name: "Palestra Online: Descubra como a formação em Análise de Sistemas pode impulsionar sua carreira no universo dos dados!",
            date: "24 de Outubro",
            theme: "Érica Bernardes - Fundação Bradesco",
            photos: [
                "/assets/Setec 24-10 - palestra online/Foto1.jpg",
                "/assets/Setec 24-10 - palestra online/Foto2.jpg",
                "/assets/Setec 24-10 - palestra online/Foto3.jpg",
                "/assets/Setec 24-10 - palestra online/Foto4.jpg",
                "/assets/Setec 24-10 - palestra online/Foto5.jpg",
                "/assets/Setec 24-10 - palestra online/Foto6.png",
                "/assets/Setec 24-10 - palestra online/Foto7.png",
                "/assets/Setec 24-10 - palestra online/Foto8.png",
                "/assets/Setec 24-10 - palestra online/Foto9.png",
                "/assets/Setec 24-10 - palestra online/Foto10.png",
                "/assets/Setec 24-10 - palestra online/Foto11.png",
                "/assets/Setec 24-10 - palestra online/Foto12.png"
            ]
        },
        {
            name: "Gincana de Halloween Tech",
            date: "24 de Outubro",
            theme: "Gincana no Espaço Multiuso para alunos de ADS - AMS",
            photos: [
                "/assets/Setec 24-10 - gincana/Foto1.jpg",
                "/assets/Setec 24-10 - gincana/Foto2.jpg",
                "/assets/Setec 24-10 - gincana/Foto3.jpg",
                "/assets/Setec 24-10 - gincana/Foto4.jpg",
                "/assets/Setec 24-10 - gincana/Foto5.jpg",
                "/assets/Setec 24-10 - gincana/Foto6.jpg",
                "/assets/Setec 24-10 - gincana/Foto7.jpg",
                "/assets/Setec 24-10 - gincana/Foto8.jpg",
                "/assets/Setec 24-10 - gincana/Foto9.jpg",
                "/assets/Setec 24-10 - gincana/Foto10.jpg",
                "/assets/Setec 24-10 - gincana/Foto11.jpg",
                "/assets/Setec 24-10 - gincana/Foto12.jpg",
                "/assets/Setec 24-10 - gincana/Foto13.jpg",
                "/assets/Setec 24-10 - gincana/Foto14.jpg",
                "/assets/Setec 24-10 - gincana/Foto15.jpg",
                "/assets/Setec 24-10 - gincana/Foto16.jpg",
                "/assets/Setec 24-10 - gincana/Foto17.jpg",
                "/assets/Setec 24-10 - gincana/Foto18.jpg",
                "/assets/Setec 24-10 - gincana/Foto19.jpg",
                "/assets/Setec 24-10 - gincana/Foto20.jpg",
                "/assets/Setec 24-10 - gincana/Foto21.jpg",
                "/assets/Setec 24-10 - gincana/Foto22.jpg",
                "/assets/Setec 24-10 - gincana/Foto23.jpg",
                "/assets/Setec 24-10 - gincana/Foto24.jpg",
                "/assets/Setec 24-10 - gincana/Foto25.jpg",
                "/assets/Setec 24-10 - gincana/Foto26.jpg",
                "/assets/Setec 24-10 - gincana/Foto27.jpg",
                "/assets/Setec 24-10 - gincana/Foto28.jpg",
                "/assets/Setec 24-10 - gincana/Foto29.jpg",
                "/assets/Setec 24-10 - gincana/Foto30.jpg",
                "/assets/Setec 24-10 - gincana/Foto31.jpg",
                "/assets/Setec 24-10 - gincana/Foto32.jpg",
                "/assets/Setec 24-10 - gincana/Foto33.jpg",
                "/assets/Setec 24-10 - gincana/Foto34.jpg",
                "/assets/Setec 24-10 - gincana/Foto35.jpg",
                "/assets/Setec 24-10 - gincana/Foto36.jpg"
            ]
        },
        {
            name: "Civap Summit Palmital - Representação da Fatec Presidente Prudente",
            date: "23 de Outubro",
            theme: "Matheus Bispo e Victor Azambuja (ADS AMS) representando a Fatec no Civap Summit em Palmital",
            photos: [
                "/assets/Civap Summit (Palmital) - 23-10/Foto1.jpg",
                "/assets/Civap Summit (Palmital) - 23-10/Foto2.jpg",
                "/assets/Civap Summit (Palmital) - 23-10/Foto3.jpg",
                "/assets/Civap Summit (Palmital) - 23-10/Foto4.jpg",
                "/assets/Civap Summit (Palmital) - 23-10/Foto5.jpg",
            ]
        },
        {
            name: "Mostra de Trabalhos no Encontro Regionalização AMS do Núcleo Regional de Administração (NRA) 08",
            date: "29 de Outubro",
            theme: "Apresentação de trabalhos dos alunos de ADS AMS no evento do NRA 08",
            photos: [
                "/assets/mostraTrabalhosAmsNRA/Foto1.jpeg",
                "/assets/mostraTrabalhosAmsNRA/Foto2.jpeg",
                "/assets/mostraTrabalhosAmsNRA/Foto3.jpeg",
                "/assets/mostraTrabalhosAmsNRA/Foto4.jpeg",
                "/assets/mostraTrabalhosAmsNRA/Foto5.jpeg",
                "/assets/mostraTrabalhosAmsNRA/Foto6.jpeg",
                "/assets/mostraTrabalhosAmsNRA/Foto7.jpeg",
            ]
        },
    ],
    Novembro: [
            {
                name: "Identificando Superfície de Ataque com Ferramentas de Pentest Online",
                date: "13 de Novembro",
                theme: "Palestrante: Sérgio Ricardo de Souza Rezende",
                photos: [
                    "/assets/fotosPalestraSegurança/Foto1.jpeg",
                    "/assets/fotosPalestraSegurança/Foto2.jpeg",
                    "/assets/fotosPalestraSegurança/Foto3.jpeg",
                    "/assets/fotosPalestraSegurança/Foto4.jpeg",
                    "/assets/fotosPalestraSegurança/Foto5.jpeg",
                    "/assets/fotosPalestraSegurança/Foto6.jpeg",
                    "/assets/fotosPalestraSegurança/Foto7.jpeg",
                    "/assets/fotosPalestraSegurança/Foto8.jpeg",
                ]
            },
            {
                name: "Apresentação Final do projeto integrador II",
                date: "27 de Novembro",
                theme: "Apresentação dos projetos finais dos alunos de ADS AMS",
                photos: [
                    "/assets/fotosPI2Final/Foto1.jpeg",
                    "/assets/fotosPI2Final/Foto2.jpeg",
                ]
            },
    ]
};